import React from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { sendVerificationEmail } from "api/auth.api";

const VerifyEmailDialog = ({ isOpen, handleClose, fullScreen = false }) => {
  return (
    <Dialog fullScreen={fullScreen} open={isOpen} onClose={handleClose}>
      <DialogContent>
        Խնդրում ենք հաստատել Ձեր էլ․ փոստի հասցեն՝ ձեր հաշվին ամբողջական մուտք
        գործելու և քվեարկելու համար: Պարզապես սեղմեք ստորև նշված կոճակը։ Ստացված
        հղումի միջոցով հաստատեք Ձեր էլ․ փոստը։
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Փակել</Button>
        <Button
          variant="contained"
          autoFocus
          onClick={() => {
            sendVerificationEmail();
            handleClose();
          }}
        >
          Ուղարկել հղում
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyEmailDialog;
